var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Lịch sử hoạt động",
        visible: _vm.isDetailHistoryAction,
        width: "1500px",
        "before-close": _vm.handleClose,
        top: "5vh",
        close: _vm.handleClose,
        "custom-class": "modern-dialog",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isDetailHistoryAction = $event
        },
        open: _vm.handleOpen,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer-themed" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "medium",
                        icon: "el-icon-circle-close",
                      },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("\n        Đóng lại\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "dialog-header-themed" }, [
        _c("div", { staticClass: "themed-icon" }, [
          _c("i", { staticClass: "el-icon-time" }),
        ]),
        _c("div", { staticClass: "themed-text" }, [
          _c("h3", [_vm._v("LỊCH SỬ CHI TIẾT HOẠT ĐỘNG CLOUD")]),
          _c("p", [
            _vm._v(
              "Theo dõi lịch trình, mốc thời gian thực hiện, kết quả xử lý và dung lượng truyền tải dữ liệu S3."
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "modern-dialog-form" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              staticClass: "modern-table",
              attrs: {
                data: _vm.listDetailHistoryAction,
                "element-loading-text": "Đang tải lịch sử chi tiết...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
                "max-height": 520,
                "summary-method": _vm.getSummaries,
                "show-summary": _vm.shouldShowSummary,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c(
                "el-table-column",
                { attrs: { label: "Thời gian thực hiện", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: "Ngày bắt đầu",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "date-time-text" }, [
                              _vm._v(_vm._s(_vm.formatDate(row.createdDate))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: "Ngày kết thúc",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.lastModifieDate === row.createdDate
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "medium",
                                      type: "primary",
                                      effect: "light",
                                    },
                                  },
                                  [_vm._v("Đến nay")]
                                )
                              : _c("span", { staticClass: "date-time-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(row.lastModifieDate))
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: "Khoảng thời gian được chọn",
                    align: "center",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: "Ngày bắt đầu",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.startDate !== null
                              ? _c("span", { staticClass: "date-time-text" }, [
                                  _vm._v(_vm._s(_vm.formatDate(row.startDate))),
                                ])
                              : _c("span", [_vm._v("—")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      label: "Ngày kết thúc",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.endDate !== null
                              ? _c("span", { staticClass: "date-time-text" }, [
                                  _vm._v(_vm._s(_vm.formatDate(row.endDate))),
                                ])
                              : _c("span", [_vm._v("—")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: { label: "Trạng thái", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge-custom",
                            class: row.delActive ? "active" : "inactive",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.statusAction) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Mô tả kết quả", "min-width": "320" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "desc-detail" }, [
                          _vm._v(_vm._s(row.description)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.codeAction === "UPLOADS3"
                ? _c("el-table-column", {
                    attrs: {
                      label: "Kích thước (MB)",
                      width: "150",
                      align: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "size-badge" }, [
                                _vm._v(
                                  _vm._s(
                                    row.sizeFiles
                                      ? row.sizeFiles.toFixed(2)
                                      : "0.00"
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1854259904
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageable.page,
                  "page-sizes": _vm.listSizePage,
                  "page-size": _vm.pageable.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalRecords,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pageable, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pageable, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }